import { normalize } from "normalizr";
import {user} from "./schema";

export const getUserList = {
  success: (response) => {
    return normalize(response, [user]);
  },
};
